var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 4.16667C5.28595 4.16667 4.16667 5.28595 4.16667 6.66667C4.16667 8.04738 5.28595 9.16667 6.66667 9.16667C8.04738 9.16667 9.16667 8.04738 9.16667 6.66667C9.16667 5.28595 8.04738 4.16667 6.66667 4.16667ZM9.44534 9.77157C10.2972 9.00865 10.8333 7.90026 10.8333 6.66667C10.8333 4.36548 8.96785 2.5 6.66667 2.5C4.36548 2.5 2.5 4.36548 2.5 6.66667C2.5 7.90026 3.03608 9.00865 3.88799 9.77157C1.59344 10.8251 0 13.1431 0 15.8333V16.6667C0 17.1269 0.373096 17.5 0.833333 17.5C1.29357 17.5 1.66667 17.1269 1.66667 16.6667V15.8333C1.66667 13.0719 3.90524 10.8333 6.66667 10.8333C9.42809 10.8333 11.6667 13.0719 11.6667 15.8333V16.6667C11.6667 17.1269 12.0398 17.5 12.5 17.5C12.9602 17.5 13.3333 17.1269 13.3333 16.6667V15.8333C13.3333 13.1431 11.7399 10.8251 9.44534 9.77157ZM16.6667 5C17.1269 5 17.5 5.3731 17.5 5.83333V7.5H19.1667C19.6269 7.5 20 7.8731 20 8.33333C20 8.79357 19.6269 9.16667 19.1667 9.16667H17.5V10.8333C17.5 11.2936 17.1269 11.6667 16.6667 11.6667C16.2064 11.6667 15.8333 11.2936 15.8333 10.8333V9.16667H14.1667C13.7064 9.16667 13.3333 8.79357 13.3333 8.33333C13.3333 7.8731 13.7064 7.5 14.1667 7.5H15.8333V5.83333C15.8333 5.3731 16.2064 5 16.6667 5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.50efb45bc2501f4af4a6761528b40c22.svg";
export { ForwardRef as ReactComponent };